import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchPostalCode = async (postalCode: string) => {
  const { data } = await apiInputService.get(
    `/frontend/postalCode/${postalCode}`,
  );

  return data;
};

export const useGetPostalCode = () => {
  return useMutation(fetchPostalCode);
};
